package com.milta.core.localization.translations.de

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Abonnement abgelaufen",
    driverSoloMessage = "Ihr Abonnement ist abgelaufen. Verlängern Sie es, um fortzufahren.",
    patronMessage = "Ihr Abonnement ist abgelaufen. Ihr Team hat keinen Zugriff mehr auf Milta.",
    driverUnderPatronMessage = "Das Abonnement Ihrer Organisation ist abgelaufen. Wenden Sie sich an Ihre Organisation, um Ihren Zugriff wiederherzustellen.",
    renewButton = "Verlängern",
    close = "Schließen",
    subscribeButtonTemplate = "Für %s abonnieren",
)
